export enum VOLUMES {
  VOLUME_1 = "VOLUME_1",
  VOLUME_2 = "VOLUME_2",
}
